import "./Footer.scss";
import cn from "classnames";
import { useState, useEffect, useRef } from "react";
import { hasCookiebotDialog, hasConsented, simplyClick } from "../../helpers";
import CookieBanner from "../CookieBanner";
import { landingId } from "../../constants";

export const Footer = () => {
  const elRef = useRef(null);
  const [hide, setHide] = useState(true);

  useEffect(() => {
    const element = elRef.current;
    if (!element) return;

    const initText = element.textContent.trim();
    let previousText = element.textContent.trim();

    const observer = new MutationObserver(() => {
      const currentText = element.textContent.trim();
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "link_disclosures",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    const timer = setTimeout(async () => {
      if (!hasConsented() && !hasCookiebotDialog()) {
        setHide(false);
      }
    }, 5000);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  const lndId =
    window.location.search === ""
      ? `?landing_id=${landingId}`
      : `&landing_id=${landingId}`;

  return (
    <>
      <div className="footer__wrapper">
        <div className={"footer-menu"} ref={elRef}>
          <div className={"block"}>
            <a
              href={`/terms-of-use${lndId}`}
              target={"_blank"}
              rel="noreferrer"
            >
              Terms of Use
            </a>
            <a
              href={`/privacy-policy${lndId}`}
              target={"_blank"}
              rel="noreferrer"
            >
              Privacy Policy
            </a>
            <a
              href={`/cookie-policy${lndId}`}
              target={"_blank"}
              rel="noreferrer"
            >
              Cookie Policy
            </a>
          </div>
          <div className={"block"}>
            <a
              href={`/refund-policy${lndId}`}
              target={"_blank"}
              rel="noreferrer"
            >
              Refund Policy
            </a>
            <a
              href={`/billing-policy${lndId}`}
              target={"_blank"}
              rel="noreferrer"
            >
              Billing Policy
            </a>
            <a
              href={`/consent-policy${lndId}`}
              target={"_blank"}
              rel="noreferrer"
            >
              Consent Policy
            </a>
            <a
              href="mailto: support@latinmelodies.com"
              target={"_blank"}
              rel="noreferrer"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
      <CookieBanner hide={hide} />
    </>
  );
};
